import {BasicDto} from "../dto/BasicDto";
import {SubscriptionSettingEntity} from "./SubscriptionSettingEntity";

export class SubscriptionEntity {
  corpId: number;
  course: BasicDto;
  courseId: number;
  courseType: BasicDto;
  courseTypeId: number;
  enabled: boolean;
  testSubscription: boolean;
  enrolled: boolean;
  comments: string;
  endDate: string;
  id: number;
  modality: BasicDto;
  modalityId: number;
  reference: string;
  site: BasicDto;
  siteId: number;
  startDate: string;
  studentId: number;
  turn: BasicDto;
  turnId: number;
  settings: SubscriptionSettingEntity;
  workgroup: number[];
  tutor: number[];
  manager: number[];
  scholarship: number[];
  staticCalendarId: number[];
  permissionRoleId: number;
  disabledReason: number;
  forumId: number;
  countryOrigin: number;

  created: string;
  updated: string;
  enabledDate: string;
  disabledDate: string;
  registerLinkUsed: string;
  enabledPraxis: boolean;
  tfmGrade: string;

  constructor() {
  }
}

